import { createSelector } from "@reduxjs/toolkit";

import { buildSingleItem, infoBlockItemMap } from "shared/utils";
import { EventBlocks, EventBlocksType, IEventInfoBlock, IGuestlistBlock } from "Bands/types";
import { getEventBlockType } from "Bands/utils";

import { dataMetaSelectorHelper, dataSelector, buildData } from "../helpers";
import { API_ENDPOINTS } from "shared/constants";

export const eventBlocksSelectorCreator = (type: EventBlocksType) =>
  createSelector(dataSelector, data => {
    const blockType = getEventBlockType(type);
    if (!blockType) return [];

    return buildData(data as any, blockType.dataKey) || [];
  });

export const eventBlockSelectorCreator = (id: string, type: EventBlocksType) =>
  createSelector(dataSelector, data => {
    const blockType = getEventBlockType(type);
    if (!blockType) return null;

    const blocks = data[blockType.dataKey];
    const block = blocks?.[blockType.api.item(id)];

    if (!block) return null;

    // merge contacts, places, files and images with data from store
    if (type === EventBlocks.infoBlock) {
      const infoBlockData = buildSingleItem(block) as IEventInfoBlock;

      infoBlockItemMap.forEach(({ key, dataKey }) => {
        const infoBlockItems: any = infoBlockData[key]
          ?.map(({ id }: { id: string }) => {
            const path = API_ENDPOINTS.INFO_BLOCK_ITEM(id, dataKey);
            const item = data[dataKey]?.[path];
            if (item) {
              return buildSingleItem(item);
            }
            return null;
          })
          .filter(item => !!item);

        infoBlockData[key] = infoBlockItems;
      });

      return infoBlockData;
    }

    if (type === EventBlocks.guestlist) {
      return buildSingleItem(block) as IGuestlistBlock;
    }

    return buildSingleItem(block);
  });

export const eventBlockMetaSelector = (id: string, type: EventBlocksType) => {
  const blockType = getEventBlockType(type);
  if (!blockType) return null;

  return dataMetaSelectorHelper(blockType.api.item(id));
};
